import { defineComponent as _defineComponent } from 'vue'
import { type ComputedRef, computed, ref, watch, toRefs, useAttrs } from 'vue'
import { useFieldError } from 'vee-validate';
import { equals, omit, path } from 'ramda'
import { useUserStore } from '@m/user/store'


export default /*@__PURE__*/_defineComponent({
  __name: 'MultilangInput',
  props: {
    value: {},
    language: {},
    innerComponent: {},
    name: {},
    form: {},
    languages: {},
    defaultLanguage: {},
    onInput: {},
    "onUpdate:isValid": {},
    "onUpdate:modelValue": {},
    "onUpdate:model": {}
  },
  emits: ['update:modelValue', 'setRules'],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const attrs = useAttrs()

const props = __props

const emit = __emit

const store = useUserStore()

const message = useFieldError(props.name);

const { name, form } = toRefs(props)

const localForm = ref((props.languages || []).reduce((acc, o) => {
  acc[(o.id || o.value)] = ''
  return acc
}, {}))

const setValue = (value, lang) => {
  if (typeof localForm.value !== 'object') {
    localForm.value = {}
  }
  localForm.value[lang] = value
  emit('update:modelValue', localForm.value)
}

const { default_language } = window

const updatedRules = ref({})
function updateRules(rule) {
  updatedRules.value = { phone: { ...rule.phone, lang: props.language } }

  emit('setRules', { 
  ...updatedRules.value
  })
}

watch(() => props.defaultLanguage, (nval) => {
  if (nval) {
    // if field is required, set rules
    if (attrs?.isRequired) {
      updatedRules.value.requiredMultilang = {
        lang: props.defaultLanguage,
        code: computed(() => updatedRules.value?.phone?.codeLength)
      }
      emit('setRules', { 
      ...updatedRules.value
     })
    }
}
}, { immediate: true })
const pathValue = (name.value || '')
  .split(/\.|\[(\d+)\]/)
  .filter(Boolean)

watch(() => form.value, (nval) => {
  if (!nval || equals(nval, localForm.value)) return 
  localForm.value = path(pathValue, nval || {})
  try {
    const temp = localForm.value[props.defaultLanguage]
    localForm.value[props.defaultLanguage] = temp
  } catch (e) {
    console.warn('Fields is not object', pathValue)
  }
}, { immediate: true, deep: true})


const __returned__ = { attrs, props, emit, store, message, name, form, localForm, setValue, default_language, updatedRules, updateRules, pathValue, computed, ref, watch, toRefs, useAttrs, get useFieldError() { return useFieldError }, get equals() { return equals }, get omit() { return omit }, get path() { return path }, get useUserStore() { return useUserStore } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})